import routerConstants from '@/constants/routerConstants'

/** Các list vận hành có lọc chi nhánh / kho trên toolbar · sidebar. */
const VAN_HANH_LIST_PATHS = new Set<string>([
  routerConstants.vanHanh.list,
  routerConstants.vanHanh.xepNhat,
  routerConstants.vanHanh.kiemTra,
  routerConstants.vanHanh.dongGoi,
  routerConstants.vanHanh.dieuPhoi,
  routerConstants.vanHanh.giaoHang,
])

/**
 * Gắn `chiNhanhIds` = chi nhánh đang login/đứng khi bấm menu Vận hành.
 * Reload / xóa lọc → URL sạch = không lọc (không tự gắn lại).
 */
export function withCurrentChiNhanhQuery(to: string, chiNhanhId: number | null): string {
  if (chiNhanhId == null || chiNhanhId <= 0) return to
  const qIndex = to.indexOf('?')
  const path = qIndex >= 0 ? to.slice(0, qIndex) : to
  if (!VAN_HANH_LIST_PATHS.has(path)) return to
  const params = new URLSearchParams(qIndex >= 0 ? to.slice(qIndex + 1) : '')
  if (!params.get('chiNhanhIds') && !params.get('chiNhanhId') && !params.get('khoVatLyIds')) {
    params.set('chiNhanhIds', String(chiNhanhId))
  }
  const qs = params.toString()
  return qs ? `${path}?${qs}` : path
}

